<template>
  <div>
    <group>
      <upload-file
        title="加油确认单"
        :params="{ path: '/billConfirm' }"
        v-model="params.oilVoucher"
        type="admin"
      ></upload-file>
    </group>
    <group>
      <x-input title="油品单价" v-model="params.price"></x-input>
      <x-input :title="title1" v-model="params.quantity"></x-input>
      <!--<x-input title="服务费" v-model="params.fee"></x-input>-->
      <cell title="实付金额">{{ ((total * 10) / 10).toFixed(2) }}</cell>
      <selector
        title="支付方式"
        direction="rtl"
        v-model="params.paymentMethod"
        :options="payOptions"
      ></selector>
      <selector
        title="*付款人"
        direction="rtl"
        v-model="params.payerClientId"
        :options="shareShipList"
      ></selector>
      <selector
        title="付款银行卡"
        direction="rtl"
        v-model="params.bankId"
        :options="bankList"
      ></selector>
      <x-textarea title="备注说明" v-model="params.remark"></x-textarea>
    </group>
    <group style="margin-bottom: 40px;">
      <x-textarea
        title="订单备注"
        v-model="params.oilVoucherRemark"
      ></x-textarea>
    </group>
    <div class="button-bottom-wrap" style="display: flex;">
      <button class="button-bottom" :disabled="disabled" @click="submit">
        确认上传
      </button>
    </div>
  </div>
</template>

<script>
import UploadFile from "@/components/Upload/UploaderFile";
import orderMixin from "@/mixin/order";
import { confirmAdminOrder } from "@/api/order";
import { adminOrderPaymentMethod, getAdminOrderDetail } from "../../api/order";
import { getAdminPayerList } from "@/api/ship";
import { adminBankActiveList } from "../../api/bank";

export default {
  props: {
    id: {
      type: String
    }
  },
  mixins: [orderMixin],
  components: { UploadFile },
  data() {
    return {
      params: {
        oilVoucher: [],
        oilVoucherRemark: "",
        price: "",
        quantity: "",
        // fee: "",
        goodsId: "",
        clientId: "",
        payerClientId: "",
        paymentMethod: "",
        bankId: "",
        remark: "",
        buyerType: ""
      },
      // clientId: "",
      payOptions: [],
      shareShipList: [],
      bankList: [],
      disabled: false,
      title1: "实际加油量()"
    };
  },
  watch: {
    "params.payerClientId"(val) {
      if (!this.params.bankId) {
        this.params.bankId = "";
      }
      if (val) {
        this.fetchBankActiveList(val);
      }
    }
  },
  computed: {
    total() {
      if (this.params.price && this.params.quantity) {
        return this.params.price * this.params.quantity;
      } else {
        return "";
      }
    }
  },
  activated() {
    this.fetchPaymentMethod();
  },
  methods: {
    fetchBankActiveList(clientId) {
      adminBankActiveList({ clientId: clientId, type: this.params.buyerType })
        .then(res => {
          this.bankList = res.map(x => {
            return {
              key: x.id,
              value: x.accountNumber
            };
          });
          if (this.bankList.length > 0) {
            this.params.bankId = this.bankList[0].key;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    fetchPayerList(clientShipId, clientId) {
      return getAdminPayerList({
        shipId: clientShipId,
        paymentMethod: this.params.paymentMethod,
        clientId: clientId,
        type: this.params.buyerType
      }).then(res => {
        this.shareShipList = res.map(x => {
          return {
            key: x.clientId,
            value: x.clientName,
            clientId: x.clientId
          };
        });
        if (this.shareShipList.length > 0) {
          if (this.params.payerClientId) {
            for (let i = 0; i < this.shareShipList.length; i++) {
              if (this.shareShipList[i].key == this.params.payerClientId) {
                this.params.payerClientId = this.shareShipList[i].clientId;
              }
            }
          } else {
            this.params.payerClientId = this.shareShipList[0].key;
          }
        }
      });
    },
    fetchPaymentMethod() {
      let that = this;
      adminOrderPaymentMethod()
        .then(res => {
          this.payOptions = res.map(x => {
            return {
              key: x.value,
              value: x.name
            };
          });
          if (this.payOptions.length > 0 && !this.params.paymentMethod) {
            this.params.paymentMethod = this.payOptions[0].key;
          }
          that.getAdminOrderDetail();
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    getAdminOrderDetail() {
      getAdminOrderDetail({ id: this.$route.params.id })
        .then(res => {
          this.title1 = "实际加油量(" + res.goodsDetails[0].unitName + ")";
          this.params.clientId = res.clientId;
          this.params.payerClientId = res.payerClientId;
          this.params.bankId = res.buyerBankId;
          this.params.buyerType = res.buyerType;
          this.params.clientShipId = res.clientShipId;
          this.fetchPayerList(this.params.clientShipId, this.params.clientId);
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    afterFetch() {
      this.params.goodsId = this.detail.goodsDetails[0].id;
      this.params.price = this.detail.goodsDetails[0].price;
      this.params.quantity = this.detail.goodsDetails[0].quantity;
    },
    submit() {
      this.disabled = true;
      this.$vux.loading.show();
      const rules = {
        price: "required",
        quantity: "required",
        oilVoucher: "array|required"
      };

      const attrs = {
        price: "实际油价",
        quantity: "实际加油量",
        oilVoucher: "加油确认单"
      };

      const params = {
        id: this.id,
        oilVoucher: this.params.oilVoucher,
        remark: this.params.remark,
        status: 1,
        oilVoucherRemark: this.params.oilVoucherRemark,
        goodsDetails: [
          {
            id: this.params.goodsId,
            price: this.params.price,
            quantity: this.params.quantity
            // fee: parseFloat(this.params.fee)
          }
        ],
        paymentMethod: this.params.paymentMethod,
        clientId: this.params.payerClientId,
        buyerBankId: this.params.bankId
      };

      this.$validate(this.params, rules, attrs)
        .then(() => {
          confirmAdminOrder(params)
            .then(() => {
              this.disabled = false;
              this.$vux.loading.hide();
              this.$showMessage("上传成功");
              this.fetchOrderDetail({ id: this.id });
              setTimeout(() => {
                this.$router.back();
              });
            })
            .catch(e => {
              this.disabled = false;
              this.$vux.loading.hide();
              this.$showError(e);
            });
        })
        .catch(e => {
          this.disabled = false;
          this.$vux.loading.hide();
          this.$showError(e, "warn");
        });
    }
  }
};
</script>

<style></style>
